import {
  getTournamentBlindsStructureRest,
  createTournamentBlindsStructureRest,
  updateTournamentFullBlindStructure,
} from '@/services/tournaments/tournaments-service';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateBlindStructureDto, UpdateBlindStructureDto, TournamentBlindStructure } from '@repo/common-types';

const useBlindStructures = () => {
  const queryClient = useQueryClient();

  const { data: blindStructures } = useQuery<CreateBlindStructureDto[]>({
    queryKey: ['blindStructures'],
    queryFn: () => getTournamentBlindsStructureRest(),
    staleTime: 60000,
  });

  const { mutate: createBlindStructure } = useMutation({
    mutationFn: (blindStructure: CreateBlindStructureDto) => createTournamentBlindsStructureRest(blindStructure),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blindStructures'] });
    },
  });

  const { mutate: updateBlindStructure } = useMutation({
    mutationFn: (blindStructure: UpdateBlindStructureDto) => updateTournamentFullBlindStructure(blindStructure),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blindStructures'] });
    },
  });

  return {
    blindStructures,
    createBlindStructure,
    updateBlindStructure,
  };
};

export default useBlindStructures;
